import React, { useEffect } from 'react'
import Table from 'components/Table'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { isNotNilOrEmpty } from 'utils/ramda'
import { changeQuery, getCurrentParsedQuery } from 'utils/navigation'
import {
  selectUngroupedCouriersList, selectUngroupedCouriersListLoading
} from 'modules/couriers/ducks/selectors'
import { fetchUngroupedCouriersListRoutine } from 'modules/couriers/ducks/actions'
import EditCourierModal from './EditCourierModal'
import { ActionsContainer } from 'theme/wrappers'

const defaultFilters = {
  page: 1,
  limit: 20,
  sort: 'name'
}

const UngroupedCouriersTable = () => {
  const dispatch = useDispatch()
  const list = useSelector(selectUngroupedCouriersList)
  const isLoading = useSelector(selectUngroupedCouriersListLoading)
  const { location: { search } } = useHistory()

  useEffect(() => {
    if (isNotNilOrEmpty(search)) {
      dispatch(fetchUngroupedCouriersListRoutine({ query: search }))
    } else {
      changeQuery(defaultFilters)
    }
  }, [search])

  useEffect(() => {
    changeQuery(defaultFilters)
  }, [])

  const handlePageChange = (_, page) => {
    const parsedQuery = getCurrentParsedQuery()
    changeQuery({
      ...parsedQuery,
      page
    })
  }

  const headers = [
    { children: 'Nazwa kuriera', sort: 'name' },
    { children: '', align: 'right' }
  ]

  const rows = list.map(row => ({
    cells: [
      { children: row.name },
      {
        children: (
          <ActionsContainer>
            <EditCourierModal courier={row} />
          </ActionsContainer>
        ),
        align: 'right',
        preventRedirect: true
      }
    ]
  }))

  return (
    <Table
      onPageChange={handlePageChange}
      headers={headers}
      rows={rows}
      isLoading={isLoading}
    />
  )
}

export default UngroupedCouriersTable
